import { useTranslation } from 'react-i18next';

import {
  AllowTextMessagesContainerStyled,
  EditButtonWrapperStyled,
  ExtraInfoStyled,
  TextMessageToggleContainerStyled,
} from 'enrollment/features';

export interface AllowPushNotificationProps {
  visible: boolean | undefined;
  checked: boolean | undefined;
}

export const AllowPushNotification = ({
  visible,
  checked,
}: AllowPushNotificationProps) => {
  const { t } = useTranslation('pages.communicationPreferencesLumos');

  if (!visible) {
    return null;
  }

  return (
    <AllowTextMessagesContainerStyled data-testid="allow-push-notifs">
      <TextMessageToggleContainerStyled className="mb-n3">
        <EditButtonWrapperStyled>
          <ps-toggle-switch
            checked={checked ? true : null}
            input-id="allow_push"
            label={t('allowPushNotification')}
            extra-class="text-dark"
          />
        </EditButtonWrapperStyled>
        <ExtraInfoStyled className="body2">
          {t('allowTextMessagesInfo')}
        </ExtraInfoStyled>
      </TextMessageToggleContainerStyled>
    </AllowTextMessagesContainerStyled>
  );
};
